






import { Vue, Component } from 'vue-property-decorator';
import auth from '@/api/auth';
import { getUserProductList } from '@/utils/fliter-pression';
@Component({})
export default class App extends Vue {
  private productList: Array<string> = []

  // 判断用户拥有的产品类别 home
  created() {
      const currentLink = window.document.location.pathname;
      const isLoginPage = currentLink.split('/').indexOf('login') !== -1;
      if (!isLoginPage) {
          auth().then((res:any) => {
              if (res.data.status === 1) {
                  const user = res.data.data && res.data.data.user;
                  this.$store.commit('setUser', user);
                  // let products = [{
                  //   name: "本机号码认证H5",
                  //   product: "onepassapi",
                  //   type: "gateway",
                  //   children: [{ name :'应用配置'}, { name :'数据统计'}]
                  // }
                  // ]
                  this.$store.dispatch('GETPRESSION', res.data.data.products).then((resp) => {
                      this.productList = getUserProductList(resp);
                  });
              } else if (res.data.data && res.data.data.link) {
                  this.$router.push({ path: `/${res.data.data.link}` });
              } else {
                  this.$router.push({ path: '/crash' });
              }
          });
      }
  }
}
